import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_hmppz48z2y: FaireBrandEntity = {
  token: "b_hmppz48z2y",
  type: "brand",
  name: "8 Days Botanicals",
  avatarUrl:
    "https://cdn.faire.com/fastly/fc91baf460a0371b13f9477c045c42c859edffbca7d3485453f53ce7e601d474.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/611b4a53ef0950abd6e1c449592fcd27ef3d75e849e30f199b908e74528a9ff3.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/fc91baf460a0371b13f9477c045c42c859edffbca7d3485453f53ce7e601d474.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/611b4a53ef0950abd6e1c449592fcd27ef3d75e849e30f199b908e74528a9ff3.jpeg",
  location: "Sebastopol, CA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 17,
  isTopShop: true,
  isInsider: true,
  description:
    "8 Days Botanicals is a modern, farm-fresh apothecary brand handcrafted by 2 sisters on a 120-acre flower farm in Sonoma County, California.\n\nIn response to the pandemic, sisters Emily and Rose found that the flowers + herbs they grew made them feel better during the toughest times. They sought out to capture that feeling in a bottle and started crafting intoxicating aromas from their most fragrant flowers and herbs. Soon enough, friends and family were asking for more and 8 Days was born.\n\nCome join us- all our mood-boosting products are enriched with active botanicals and farm-fresh plants to feel better 8 Days a week! :)\n",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:15.848Z",
    importedBy: "entity-db-cli",
  },
};
